"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageModule = void 0;
const base_1 = require("./base");
class PageModule extends base_1.SurveyModule {
    constructor({ modules = [], compact = false, ...rest }) {
        super(rest);
        this._type = "page";
        this.modules = modules;
        this.compact = compact;
    }
    validate() {
        return true;
    }
    toBuilderConfig() {
        if (this.validate()) {
            const surveyConfigModule = {
                compact: this.compact,
                modules: this.modules.map((mod) => mod.toBuilderConfig()),
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                surveyConfigModule.tag = this.tag;
            }
            return surveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    toSurveyConfig() {
        if (this.validate()) {
            const SurveyConfigModule = {
                compact: this.compact,
                modules: this.modules.flatMap((mod) => mod.toSurveyConfig()),
                style: this.style,
                type: this.type,
            };
            if (this.tag) {
                SurveyConfigModule.tag = this.tag;
            }
            return SurveyConfigModule;
        }
        throw new Error((0, base_1.INVALID_MODULE)(this));
    }
    editProps() {
        return undefined;
    }
}
exports.PageModule = PageModule;
//# sourceMappingURL=Page.js.map